// Tracks navigation context when viewing a skill with a single installation location.
// This allows the LHN to highlight the appropriate entity (org, team, repo, or personal)
// instead of "All Skills" when viewing a skill installed in exactly one place.

import type { VaultAssetInstallationEntityType } from '~/codegen/graphql'

export interface SkillNavigationContext {
  entityType: VaultAssetInstallationEntityType | null
  entityId: string | null
  entityName: string | null
  monoRepoConfigId?: string | null
  monoRepoConfigName?: string | null
}

const context = ref<SkillNavigationContext>({
  entityType: null,
  entityId: null,
  entityName: null,
  monoRepoConfigId: null,
  monoRepoConfigName: null,
})

export default function useSkillNavigationContext() {
  function setContext(newContext: SkillNavigationContext) {
    context.value = newContext
  }

  function clearContext() {
    context.value = {
      entityType: null,
      entityId: null,
      entityName: null,
      monoRepoConfigId: null,
      monoRepoConfigName: null,
    }
  }

  return {
    context: readonly(context),
    setContext,
    clearContext,
  }
}
